import * as React from 'react';

import styles from './mfa-body.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

MfaBody.defaultProps = {
    as: 'div',
};

export function MfaBody({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['mfa-body']}>{children}</Tag>;
}
